import React, { forwardRef } from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

export default withTranslation()(function RewardAdsRowActions({ t, campaign, onViewDetails, onEdit, onDuplicate, onViewAnalytics, onEndCampaign }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background"
          >
            <UIcons.UilEllipsisV size={18} className="text-secondary" />
          </button>

          {
            open && (
              <div className="absolute right-0 top-10 z-20 w-52 bg-white border border-border-lines rounded-xl shadow-lg py-2">
                <button
                  type="button"
                  onClick={() => { onViewDetails(campaign); handleClick() }}
                  className="w-full flex items-center gap-2 text-left px-4 py-2 text-sm text-dark-blue hover:bg-background"
                >
                  <UIcons.UilInfoCircle size={16} /> {t('rewardAds.listing.actions.view_details')}
                </button>

                <button
                  type="button"
                  onClick={() => { onEdit(campaign); handleClick() }}
                  className="w-full flex items-center gap-2 text-left px-4 py-2 text-sm text-dark-blue hover:bg-background"
                >
                  <UIcons.UilEditAlt size={16} /> {t('rewardAds.listing.actions.edit')}
                </button>

                <button
                  type="button"
                  onClick={() => { onDuplicate(campaign); handleClick() }}
                  className="w-full flex items-center gap-2 text-left px-4 py-2 text-sm text-dark-blue hover:bg-background"
                >
                  <UIcons.UilCopy size={16} /> {t('rewardAds.listing.actions.duplicate')}
                </button>

                <button
                  type="button"
                  onClick={() => { onViewAnalytics(campaign); handleClick() }}
                  className="w-full flex items-center gap-2 text-left px-4 py-2 text-sm text-dark-blue hover:bg-background"
                >
                  <UIcons.UilChartLine size={16} /> {t('rewardAds.listing.actions.view_analytics')}
                </button>

                <button
                  type="button"
                  onClick={() => { onEndCampaign(campaign); handleClick() }}
                  className="w-full flex items-center gap-2 text-left px-4 py-2 text-sm text-danger hover:bg-background"
                >
                  <UIcons.UilTimesSquare size={16} /> {t('rewardAds.listing.actions.end_campaign')}
                </button>
              </div>
            )
          }
        </div>
      ))}
    />
  )
})
